<template>
    <div>
      <ckeditor :editor="editor" v-model="editorData" ref="editor"></ckeditor>
    </div>
  </template>
  
  <script>
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  
  export default {
    components: {
      ckeditor: CKEditor.component,
    },
    data() {
      return {
        editorData: '<p>Initial content</p>',
        editor: ClassicEditor,
      };
    },
    created() {
      this.editor.defaultConfig = {
        ...this.editor.defaultConfig,
        toolbar: ['heading', '|', 'bold', 'italic', '|', 'link', 'bulletedList', 'numberedList', 'blockQuote', 'insertTable'],
      };
    },
  };
  </script>
  